<template>
  <div>
    选择数据日期：
    <a-range-picker @change="onChange" />
    <p>注意：选择时间跨度越大，数据加载时间越久。建议时间跨度不超过 1 个月</p>
    <div style="margin-top: 15px">
      <a-table
        :columns="reportColumns"
        :dataSource="reportGroupData"
        size="small"
        :rowKey="(record) => record.groupname"
        bordered
        :loading="loadingA"
        :pagination="pagination"
      >
        <div slot="allMaxcalltime" slot-scope="text">
          {{ text | stom }}
        </div>
        <div slot="allCalltimecount" slot-scope="text">{{ text | stom }}</div>
        <div slot="allAvgcalltime" slot-scope="text">{{ text | stom }}</div>
      </a-table>

      <a-table
        :columns="columns"
        :dataSource="ReportDashboardData"
        size="small"
        :rowKey="(record) => record.PersonID"
        bordered
        :loading="loadingB"
        :pagination="pagination"
      >
        <div slot="TookFollowPercent" slot-scope="record">
          {{
            transformToPercent(
              record.Product1104CalledAftertooked2days,
              record.Product1104TookCount
            )
          }}
        </div>
        <div slot="ScheduleFollowPercent" slot-scope="record">
          {{
            transformToPercent(
              record.Product1104CalledAfterscheduled2days,
              record.Product1104ScheduleCount
            )
          }}
        </div>
        <div slot="maxcalltime" slot-scope="text">
          {{ text | stom }}
        </div>
        <div slot="CalltimeValidPercent" slot-scope="text, record">
          {{
            (
              (record.Calltimecount /
                (27000 *
                  (1 +
                    (new Date(dateEnd) - new Date(dateStart)) /
                      (1000 * 60 * 60 * 24)))) *
              100
            ).toFixed(2) + "%"
          }}
        </div>
        <div slot="avgcalltime" slot-scope="text">{{ text | stom }}</div>
        <div slot="calltimecount" slot-scope="text">{{ text | stom }}</div>
        <div slot="smscount" slot-scope="text, record">
          <a
            href="javascript:;"
            @click="showSMSSendHistory(record.PersonID, text)"
            >{{ text }}</a
          >
        </div>
      </a-table>
    </div>
    <a-modal
      title="短信发送情况"
      :visible="showSMSSendListModal"
      :width="800"
      :dialog-style="{ top: '20px' }"
    >
      <a-table
        :columns="smsListColumns"
        :dataSource="smsListData"
        size="small"
        :rowKey="(record) => record.context"
        bordered
      >
      </a-table>
      <template slot="footer">
        <a-button
          key="back"
          @click="
            () => {
              this.showSMSSendListModal = false;
            }
          "
        >
          关闭
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { GetReportDashboard, GetSMSSendHistoryWithPersonID } from '@/api/QkidsApi.js'
import moment from 'moment'
const columns = [
  { title: '顾问组', width: 120, fixed: 'left', dataIndex: 'Groupname', key: 'groupname', onFilter: (value, record) => record.Groupname.indexOf(value) === 0 },
  { title: '顾问', width: 100, fixed: 'left', dataIndex: 'Personname', key: 'personname' },
  { title: '总通话数', dataIndex: 'Callcount', key: 'callcount', sorter: (a, b) => a.Callcount - b.Callcount },
  { title: '有效通话数', dataIndex: 'Validcall', key: 'validcall', sorter: (a, b) => a.Validcall - b.Validcall },
  { title: '最长通话时长', dataIndex: 'Maxcalltime', key: 'maxcalltime', scopedSlots: { customRender: 'maxcalltime' }, sorter: (a, b) => a.Maxcalltime - b.Maxcalltime },
  { title: '平均通话时长', dataIndex: 'Avgcalltime', key: 'avgcalltime', scopedSlots: { customRender: 'avgcalltime' }, sorter: (a, b) => a.Avgcalltime - b.Avgcalltime },
  { title: '有效通话总时长', dataIndex: 'Calltimecount', key: 'calltimecount', scopedSlots: { customRender: 'calltimecount' }, sorter: (a, b) => a.Calltimecount - b.Calltimecount },
  { title: '有效接听率', dataIndex: 'Validcallrate', key: 'validcallrate', sorter: (a, b) => parseFloat(a.Validcallrate.replace('%', '')) - parseFloat(b.Validcallrate.replace('%', '')) },
  {
    title: '工时利用率',
    dataIndex: 'CalltimeValidPercent',
    key: 'CalltimeValidPercent',
    scopedSlots: { customRender: 'CalltimeValidPercent' },
    sorter (a, b) {
      let av = parseFloat((a.Calltimecount / 27000) * 100)
      let bv = parseFloat((b.Calltimecount / 27000) * 100)
      return av - bv
    }
  },
  { title: '短信发送', dataIndex: 'Smscount', key: 'smscount', scopedSlots: { customRender: 'smscount' }, sorter: (a, b) => a.Smscount - b.Smscount }
]

const reportColumns = [
  { title: '顾问组1', dataIndex: 'groupname', key: 'avggroupname', onFilter: (value, record) => record.groupname.indexOf(value) === 0 },
  { title: '平均总通话数', dataIndex: 'allCallcount', key: 'allCallcount', sorter: (a, b) => a.allCallcount - b.allCallcount },
  { title: '平均有效通话数', dataIndex: 'allValidcall', key: 'allValidcall', sorter: (a, b) => a.allValidcall - b.allValidcall },
  { title: '平均最长通话时长', dataIndex: 'allMaxcalltime', key: 'allMaxcalltime', scopedSlots: { customRender: 'allMaxcalltime' }, sorter: (a, b) => a.allMaxcalltime - b.allMaxcalltime },
  { title: '平均有效总通话时长', dataIndex: 'allCalltimecount', key: 'allCalltimecount', scopedSlots: { customRender: 'allCalltimecount' }, sorter: (a, b) => a.allCalltimecount - b.allCalltimecount },
  { title: '平均有效通话时长', dataIndex: 'allAvgcalltime', key: 'allAvgcalltime', scopedSlots: { customRender: 'allAvgcalltime' }, sorter: (a, b) => a.allAvgcalltime - b.allAvgcalltime },
  { title: '平均有效接听率', dataIndex: 'allAvgCallValidPersent', key: 'allAvgCallValidPersent', sorter: (a, b) => parseFloat(a.allAvgCallValidPersent.replace('%', '')) - parseFloat(b.allAvgCallValidPersent.replace('%', '')) }

]
const smsListColumns = [
  { title: '短信内容', dataIndex: 'Context', key: 'context' },
  { title: '发送数量', dataIndex: "SmsCount", key: 'smscount', sorter: (a, b) => a.SmsCount - b.SmsCount }
]
var smsListData = []

let reportGroup = {}
let reportGroupData = []

export default {
  name: 'ReportDashboard',
  data: function () {
    return {
      columns,
      dateStart: '',
      dateEnd: '',
      ReportDashboardData: [],
      loadingA: false,
      loadingB: false,
      showSMSSendListModal: false,
      pagination: {
        defaultPageSize: 15,
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['15', '30', '50']
      },
      smsListColumns,
      smsListData,
      reportColumns,
      reportGroup,
      reportGroupData,
      difDay: 1

    }
  },
  methods: {
    showSMSSendHistory (personID, num) {
      if (num != 0) {
        console.log(personID, this.dateStart, this.dateEnd, num)
        GetSMSSendHistoryWithPersonID(personID, this.dateStart, this.dateEnd).then(req => {
          console.log(req)
          this.showSMSSendListModal = true
          this.smsListData = req.data
        })
      } else {
        console.log("is zero")
      }
    },
    transformToPercent: function (val, val2) {
      if (val2 === 0 || val === 0) {
        return '0%'
      } else {
        let per = ((val / val2) * 100).toFixed(2) + '%'
        return per
      }
    },
    moment,
    dateBefor: function () {
      this.reportDate = moment('2019-06-30')
      console.log('befor' + this.GetDateStr(-1))
    },
    dateAfter: function () {
      this.reportDate = moment('2019-06-29')
      console.log('after' + moment('2019-06-29'))
    },
    GetDateStr (AddDayCount) {
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1
      var d = dd.getDate()
      return y + '-' + m + '-' + d
    },
    onChange: function (date, dateString) {
      this.loadingA = true
      this.loadingB = true
      this.dateStart = dateString[0]
      this.dateEnd = dateString[1]
      console.log(this.dateStart, this.dateEnd)
      this.difDay = ((new Date(this.dateEnd) - new Date(this.dateStart)) / (1000 * 60 * 60 * 24)) + 1
      console.log('相差天数：' + this.difDay)
      console.log(this.selectPersonId, dateString)
      GetReportDashboard(this.dateStart, this.dateEnd)
        .then(req => {
          this.loadingA = false
          this.loadingB = false
          console.log(req)
          this.ReportDashboardData = req.data
          let groupArr = []
          let groupFiletrsArr = []
          let reportGroupFiltersArr = []
          req.data.forEach(item => {
            if (groupArr.indexOf(item.Groupname) === -1) {
              groupArr.push(item.Groupname)
              groupFiletrsArr.push({ text: item.Groupname, value: item.Groupname })
              if (item.Validcall !== 0) {
                reportGroup[item.Groupname] = {
                  allCallcount: item.Callcount,
                  allValidcall: item.Validcall,
                  allMaxcalltime: item.Maxcalltime,
                  allAvgcalltime: item.Avgcalltime,
                  allCalltimecount: item.Calltimecount,
                  dataCount: 1
                }
              } else {
                reportGroup[item.Groupname] = {
                  allCallcount: 0,
                  allValidcall: 0,
                  allMaxcalltime: 0,
                  allAvgcalltime: 0,
                  allCalltimecount: 0,
                  dataCount: 0
                }
              }
            } else {
              if (item.Validcall !== 0) {
                reportGroup[item.Groupname] = {
                  allCallcount: reportGroup[item.Groupname].allCallcount + item.Callcount,
                  allValidcall: reportGroup[item.Groupname].allValidcall + item.Validcall,
                  allMaxcalltime: reportGroup[item.Groupname].allMaxcalltime + item.Maxcalltime,
                  allAvgcalltime: reportGroup[item.Groupname].allAvgcalltime + item.Avgcalltime,
                  allCalltimecount: reportGroup[item.Groupname].allCalltimecount + item.Calltimecount,
                  dataCount: reportGroup[item.Groupname].dataCount + 1
                }
              }
            }
          })
          let tmpReportGroupData = []
          // CC组均值
          let sumCallCount = 0
          let sumValidcall = 0
          let sumMaxcalltime = 0
          let sumCalltimecount = 0
          let sumAvgcalltime = 0
          let sumCount = 0


          groupArr.forEach(item => {
            reportGroup[item].groupname = item
            reportGroupFiltersArr.push({ text: item, value: item })
            // 剔除不存在有效数据的统计
            if (reportGroup[item].dataCount !== 0) {
              reportGroup[item].allCallcount = ((reportGroup[item].allCallcount / reportGroup[item].dataCount) / this.difDay).toFixed(2)
              reportGroup[item].allValidcall = ((reportGroup[item].allValidcall / reportGroup[item].dataCount) / this.difDay).toFixed(2)
              reportGroup[item].allMaxcalltime = (reportGroup[item].allMaxcalltime / reportGroup[item].dataCount).toFixed(2)
              reportGroup[item].allAvgcalltime = (reportGroup[item].allAvgcalltime / reportGroup[item].dataCount).toFixed(2)
              reportGroup[item].allCalltimecount = ((reportGroup[item].allCalltimecount / reportGroup[item].dataCount) / this.difDay).toFixed(2)
              reportGroup[item].allAvgCallValidPersent = ((reportGroup[item].allValidcall / reportGroup[item].allCallcount).toFixed(2) * 100).toFixed(0) + '%'
              tmpReportGroupData.push(reportGroup[item])

              if (item.indexOf('CC') !== -1) {
                // if ((item.indexOf('admin') === -1) && (item.indexOf('测试') === -1) && (item.indexOf('离职') === -1)) {
                sumCallCount += parseFloat(reportGroup[item].allCallcount)
                sumValidcall += parseFloat(reportGroup[item].allValidcall)
                sumMaxcalltime += parseFloat(reportGroup[item].allMaxcalltime)
                sumCalltimecount += parseFloat(reportGroup[item].allCalltimecount)
                sumAvgcalltime += parseFloat(reportGroup[item].allAvgcalltime)
                sumCount++
              }
            }
          })
          tmpReportGroupData.push({
            groupname: 'CC组平均',
            allCallcount: (sumCallCount / sumCount).toFixed(2),
            allValidcall: (sumValidcall / sumCount).toFixed(2),
            allMaxcalltime: (sumMaxcalltime / sumCount).toFixed(2),
            allAvgcalltime: (sumAvgcalltime / sumCount).toFixed(2),
            allCalltimecount: (sumCalltimecount / sumCount).toFixed(2),
            allAvgCallValidPersent: ((sumValidcall / sumCallCount).toFixed(2) * 100).toFixed(0) + '%'
          })
          reportGroupFiltersArr.push({ text: 'CC组平均', value: 'CC组平均' })
          this.reportGroupData = tmpReportGroupData
          this.reportColumns[0].filters = reportGroupFiltersArr
          this.columns[0].filters = groupFiletrsArr
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  filters: {
    stom: (value) => {
      var secondTime = parseInt(value)
      var minuteTime = 0
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
      }
      var result = '' + parseInt(secondTime) + '秒'
      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      return result
    }
  }
}
</script>
